import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.25, 0.1, 0.25, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, sub, align = "left", testId }) => (
  <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-3xl"}>
    {overline && (
      <Reveal>
        <p className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-gold-deep ${align === "center" ? "justify-center" : ""}`} data-testid={testId ? `${testId}-overline` : undefined}>
          <span className="h-px w-8 bg-gold" />
          {overline}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-heading text-3xl font-bold leading-tight tracking-tight text-navy md:text-5xl" data-testid={testId ? `${testId}-title` : undefined}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-gray-600 md:text-lg" data-testid={testId ? `${testId}-sub` : undefined}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
